// tslint:disable:max-classes-per-file
import BetModel from "../../core/src/model/BetModel";
import debugModel from "../../core/src/model/DebugModel";
import GameModel from "../../core/src/model/GameModel";
import { IRequestBuilder } from "../../core/src/server/requests/RequestBuilder";
import SpinModel from "../../core/src/model/SpinModel";
import VendorModel from "../model/VendorModel";
import SoundController from "../../core/src/utils/SoundController";
import { ISavedSettings } from "../../core/src/model/ISavedSettings";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import { version } from "../../../package.json"
import { ConfigurationTypes } from '../../core/src/const/ConfigurationTypes';
import ConfigManager from '../../core/src/managers/ConfigManager';
import IVendorClientConfigRequestData from './contracts/IVendorClientConfigRequestData';
import ConsoleUtil from '../../core/src/utils/ConsoleUtil';
declare const DEBUG: boolean;
export class LoginRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/rmlogin";
  }

  get requestData() {
    return {
      token: GameModel.playerToken,
      userid: GameModel.playerConfig.userId,
      mode: GameModel.mode,
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      channel: GameModel.urlParams.channel,
      partnerid: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).partnerId,
      acceptFreespinsMidsession: true,
    };
  }
}

export class FunLoginRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/funmoneylogin";
  }

  get requestData() {
    return {
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      channel: GameModel.urlParams.channel,
      currency: GameModel.currency || "EUR",
      partnerid: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).partnerId,
      clientid: GameModel.urlParams.clientid || ""
    };
  }
}

export class TokenRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.tokenApi;
  }

  get requestData() {
    return {
      ticket: GameModel.urlParams.ticket, // should be put into the game model
      partnerid: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).partnerId,
      channel: GameModel.urlParams.channel || "web",
      gameref: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      clientid: GameModel.urlParams.clientid
    };
  }
}

/**
 * Used to get recovery(resume) data from server. Currently refresh data is being send when the login is made.
 * Maybe this is used somewhere else ?
 */
export class RefreshRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/refresh";
  }

  get requestData() {
    return {
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      sid: GameModel.sessionID
    };
  }
}

export class GetBalanceRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/getbalance"
  }

  get requestData() {
    return {
      sid: GameModel.sessionID
    }
  }
}

export class GetSessionRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/getsessionresult"
  }

  get requestData() {
    return {
      sid: GameModel.sessionID
    }
  }
}

export class PlayRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/play";
  }

  get requestData() {
    let forcedOutcome;
    if (DEBUG && debugModel.debugData) {
      forcedOutcome = debugModel.debugData;
      debugModel.cleanUp();
    }

    let lastRestoreVersion = GameModel.restoreVersion;
    GameModel.incrementRestoreVersion();
    let index =
      SpinModel.currentGeneration && SpinModel.generations
        ? SpinModel.generations[SpinModel.currentGeneration].index
        : 0;
    let state = JSON.stringify({
      generation: index,
      roundFinished: SpinModel.roundFinish,
      restoreVersion: GameModel.restoreVersion
    });

    if (!VendorModel.inFreeGames) {

      return {
        sid: GameModel.sessionID,
        g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
        ga: "spin", // gameAction
        ba: BetModel.totalBet, // betAmount
        forcedOutcome,
        restoreState: state,
        restoreVersion: lastRestoreVersion
      }
    } else {
      return {
        sid: GameModel.sessionID,
        g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
        ga: "spin", // gameAction
        ba: VendorModel.freeGames.ba,
        restoreState: state,
        restoreVersion: lastRestoreVersion
      }
    }
  }
}

export class ReplayRequest implements IRequestBuilder {
  // gameReplayServiceURL
  get method() {
    return "GET";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.replayApi;
  }

  get requestData() {
    let data = {
      replaytoken: GameModel.replayToken,
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      lang: GameModel.lang
    };

    console.log("[Requests] ReplayRequest", data);

    return data;
  }
}

export class SkipFreeGamesRequest implements IRequestBuilder {
  get method() {
    return "GET";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/freespins";
  }

  get requestData() {
    return {
      sid: GameModel.sessionID,
      action: "skip"
    };
  }
}
export class HasFreeGamesRequest implements IRequestBuilder {
  get method() {
    return "GET";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/ping";
  }

  get requestData() {
    return {
      sid: GameModel.sessionID,
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      ga: "deal", // gameAction
      expectFreeRounds: true,
    };
  }
}

export class CancelFreeGamesRequest implements IRequestBuilder {
  get method() {
    return "GET";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/freespins";
  }

  get requestData() {
    return {
      sid: GameModel.sessionID,
      action: "delete"
    };
  }
}

export class SaveRestoreStateRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/setrestorestate";
  }

  get requestData() {
    let lastRestoreVersion = GameModel.restoreVersion;
    GameModel.incrementRestoreVersion();
    let index =
      SpinModel.currentGeneration && SpinModel.generations
        ? SpinModel.generations[SpinModel.currentGeneration].index
        : 0;
    let state = JSON.stringify({
      generation: index,
      roundFinished: SpinModel.roundFinish,
      restoreVersion: GameModel.restoreVersion
    });

    return {
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      restoreState: state,
      restoreVersion: lastRestoreVersion,
      sid: GameModel.sessionID
    };
  }
}

export class FinishRound implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/gamefinished";
  }

  get requestData() {
    let data = {
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      restoreVersion: GameModel.restoreVersion,
      sid: GameModel.sessionID
    };

    // console.log("[Requests] Finish Round", data);
    return data;
  }
}

export class SaveSettingsRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/setsavedsettings";
  }

  get requestData() {
    return <{ g: string; sid: string; savedSettings: ISavedSettings }>{
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      sid: GameModel.sessionID,
      savedSettings: {
        sound: {
          effects: SoundController.isEffectsEnabled,
          music: SoundController.isMusicEnabled
        },
        bet: {
          currentBet: BetModel.coinSizeIndex
        },
        autoplay: {
          spins: AutoplayModel.getAutoSpinNum(),
          lossLimit: AutoplayModel.getLossLimit(),
          winLimit: AutoplayModel.getWinLimit()
        }
      }
    };
  }
}

export class ClientConfigRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    // return "https://dev-casino-client.api.relaxg.net/capi/1.0/casino/games/getclientconfig";

    return ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).clientconfigurl

  }

  get requestData() {
    let requestParams = {
      gameref: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      partnerid: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).partnerId,
      channel: GameModel.urlParams.channel || "web",
      jurisdiction: GameModel.urlParams.jurisdiction,
      versionstring: `game:${version}`,
    };

    return requestParams;
  }
}
export class ClientConfigURLRequest implements IRequestBuilder {
  get method() {
    return "GET";
  }

  get path() {
    // ConsoleUtil.green(`${location.protocol}//${location.host}/casino/cdnconfig.json`)
    return `${location.protocol}//${location.host}/casino/cdnconfig.json`
  }

  get requestData() {
    let requestParams = {};
    return requestParams;
  }
}

export class SetRealityCheckLimits implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/setrealitychecklimits";
  }

  get requestData() {
    let data = {
      sid: GameModel.sessionID,
      // TODO: How and where? lossLimit: 1000,
      sessionLimitSeconds: GameModel.urlParams.rcinterval,
      sessionElapsedSeconds: GameModel.urlParams.rcelapsed
    };

    console.log("[Requests] Set Reality Check Limits", data);
    return data;
  }
}

export class ResetRealityCheck implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/resetrealitycheck";
  }

  get requestData() {
    let data = {
      sid: GameModel.sessionID,
      loss: false, // TODO: should be correctly set
      sessionLength: true // TODO: should be correctly set
    };

    console.log("[Requests] Set Reality Check Limits", data);
    return data;
  }
}
